<template>
  <div class="cookiespolicy-view">
    <h1 class="agreement-title">Cookies策略</h1>
    <div class="agreement-content">
      <div class="agreement-content-text">
        <p>Cookie是在您访问网站时您的浏览器收到的小型数据文件。我们会使用自己的Cookie和第三方Cookie来执行多项不同的操作：</p>
        <p>Ⅰ.让您登录到我们的服务。</p>
        <p>Ⅱ.记住首选项和设置。</p>
        <p>Ⅲ.保护您帐户的安全。</p>
        <p>Ⅳ.更好地了解用户如何使用我们的服务，并根据这些信息对服务进行完善及推广。</p>
        <p>Ⅴ.易趣团队使用Cookie来收集有关您的在线活动数据并发现您的兴趣所在，以便我们提供与您相关度最高的广告。</p>
        <p>Ⅵ.我们使用第一方和第三方Cookie和其他标识符来收集用法和性能数据。例如，我们可能使用Cookie来计算网页或者服务的独立访客的人数，以及开发关于我们的产品运营的其他统计资料。</p>
        <p>Ⅶ.易趣团队使用Cookie来了解和改进我们产品的性能。 例如，我们使用Cookie收集有助于负载平衡的数据；这有助于确保我们的网站保持正常运行。</p>
        <p>您使用我们的服务时，我们会在您的计算机或移动设备上存储名为 Cookie 的小数据文件。Cookie通常包含标识符、站点名称以及一些号码和字符。我们使用该等信息判断注册用户是否已经登录，提升服务/产品质量及优化用户体验。如您不希望个人信息保存在 Cookie 中，您可对浏览器进行配置，选择禁用Cookie功能。禁用Cookie功能后，可能影响您访问易趣团队或不能充分获得易趣团队提供的服务。</p>
        <p>易趣团队不会将Cookie用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除Cookie。您可以清除计算机上保存的所有Cookie，大部分网络浏览器都设有阻止 Cookie 的功能。</p>
      </div>
    </div>
  </div>
</template>

<style scoped>
.cookiespolicy-view {
  width: 1200px;
  margin: 0 auto;
  min-height: 50vh;
  margin-top: 40px;
  margin-bottom: 80px;

  .agreement-title {
    text-align: center;
    text-wrap-mode: wrap;
    text-align: center;
    margin-top: 15px;
  }

  .agreement-content {
    text-wrap-mode: wrap;
    text-align: justify;

    p {
      font-size: 18px;
      line-height: 30px;
      margin-bottom: 18px;
      margin-top: 18px;
    }
  }
}

</style>

<script lang="ts" setup>
/* definePageMeta()是编译器宏，不用实际代码运行 */
definePageMeta({
})
</script>

